// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__3mJvZ","flex":"Button_flex__3JHdl","imageDiv":"Button_imageDiv__2ylyl","img":"Button_img__2kPT-"};